import type { Candidate } from '../repository'

import ctaBannerMeta from '@cogo/schema/blocks-v2/cta/cta-banner/block.cogo.json'
import ctaBannerUi from '@cogo/schema/blocks-v2/cta/cta-banner/ui.cogo.json'
import ctaBannerEvents from '@cogo/schema/blocks-v2/cta/cta-banner/events.cogo.json'
import ctaBannerFlow from '@cogo/schema/blocks-v2/cta/cta-banner/flow.cogo.json'
import ctaBannerVariables from '@cogo/schema/blocks-v2/cta/cta-banner/variables.cogo.json'
import ctaBannerDatasource from '@cogo/schema/blocks-v2/cta/cta-banner/datasource.cogo.json'
import { cloneBlockDef, appendRootClassName } from './util'

function buildCtaVariant(variant: 'default' | 'centered' | 'compact') {
  const base = cloneBlockDef({
    meta: ctaBannerMeta,
    ui: ctaBannerUi,
    events: ctaBannerEvents,
    flow: ctaBannerFlow,
    state: ctaBannerVariables,
    data: ctaBannerDatasource,
  })
  if (variant === 'centered') appendRootClassName(base, 'text-center items-center')
  if (variant === 'compact') appendRootClassName(base, 'py-4')
  return base
}

export const chatCandidates: Candidate[] = [
  {
    id: 'chat-a',
    exampleId: 'cexample:cta-banner-default',
    patternId: 'cpat:cta-banner',
    dsId: 'ds:shadcn',
    cogoJson: buildCtaVariant('default'),
    narrativeHeadline: 'CTA banner · standard call-to-action strip',
    dsCompatibility: 'exact',
    score: 90,
  },
  {
    id: 'chat-b',
    exampleId: 'cexample:cta-banner-centered',
    patternId: 'cpat:cta-banner',
    dsId: 'ds:shadcn',
    cogoJson: buildCtaVariant('centered'),
    narrativeHeadline: 'Centered CTA banner · hero-style emphasis',
    dsCompatibility: 'exact',
    score: 85,
  },
  {
    id: 'chat-c',
    exampleId: 'cexample:cta-banner-compact',
    patternId: 'cpat:cta-banner',
    dsId: 'ds:shadcn',
    cogoJson: buildCtaVariant('compact'),
    narrativeHeadline: 'Compact CTA banner · inline nudge',
    dsCompatibility: 'adjacent',
    score: 75,
  },
]
